/** The first fiscal year whose acknowledgment goes through the plan review before the signature. */
export const PLAN_REVIEW_BEFORE_SIGN_FIRST_FYEAR = 2027

/** Up to FY26 a signature is sent straight away, as it was before the plan review. */
export const isPlanReviewBeforeSign = (fYear: number) =>
  fYear >= PLAN_REVIEW_BEFORE_SIGN_FIRST_FYEAR
